module.exports = __webpack_public_path__ + "static/background-3eb1f63759827be35c91bc14b85bb01b.png";